export const selectContentStyle = theme => ({
    marginSearch: {
        marginTop: 10
    },
})